// src/components/ScrollTopButton.js
import React, { useEffect, useState } from 'react';

const ScrollTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 520);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className={`scroll-top-button ${visible ? 'visible' : ''}`}
      type="button"
      onClick={scrollToTop}
      aria-label="Наверх"
    >
      ↑
    </button>
  );
};

export default ScrollTopButton;
